import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "No flight to Seattle — we handle agency submission remotely",
      "Ideal for state legislators and lobbyists traveling during session",
      "Perfect for UAS students studying abroad",
      "Great for Juneau cruise and tourism industry professionals",
      "Alaska Airlines frequent flyers from JNU",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — bypasses Alaska mail delays",
      "Faster than self-service at Juneau USPS",
      "Good for planned international trips from JNU via Seattle",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only through Alaska postal system",
      "Juneau Mendenhall post office is primary acceptance facility",
      "Mail from Southeast Alaska takes 5–10 extra business days each direction",
      "No document review — errors cause rejection and restart",
      "In-person clerk appointment required",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "No passport agency in Alaska — closest is Seattle, flight required",
      "Juneau to Seattle: 2+ hour flight, $400+ round-trip airfare on top of fees",
      "NPIC appointment required — no walk-ins at Seattle agency",
      "Life-or-death emergencies only with documentation",
      "Alaska weather can cancel flights — plan for multi-day Seattle stay",
      "Expect to spend $800+ on airfare + hotel before agency fees",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Juneau"
      headingExtra="AK"
      introText="Juneau travelers — state legislators commuting to the capitol, UAS students preparing for study abroad, Alaska Airlines flyers connecting through Seattle, cruise industry professionals with international contracts, and Southeast Alaska families — have several options for getting a passport fast. Here is how they compare, and why most Alaskans choose a U.S. Department of State registered passport courier rather than paying for a flight to Seattle just to submit paperwork."
      options={options}
      emergencyDescription="Alaska has no regional passport agency. The closest is in Seattle — a 2+ hour flight from Juneau that costs $400+ round-trip, plus hotel. NPIC appointment is mandatory, and Juneau weather can disrupt travel. Expect to spend $800+ before you even pay agency fees."
      disclaimerText="*Processing speed depends on eligibility and documentation. Alaska has no passport agency — the closest is Seattle, WA, requiring air travel. Not all applicants qualify for Regional Agency Processing."
    />
  );
}